import { axios } from './CustomAxios'

//const url = 'https://api.panstone.group:9999/client'
const url = 'https://antlab-api.zjian.cc:9999/client'

const api = {
  rescheduleCalenders: `${url}/calender/reschedule/list`,
  calenders: `${url}/calender/list`,
  schedules: `${url}/schedule/`,
  user: `${url}/user/`,
  resConfirm: `${url}/res/confirm`,
  resAbort: `${url}/res/abort`,
  resCancel: `${url}/res/cancel`,

  resReschedule: `${url}/res/reschedule`,

  queueInfo: `${url}/user/queueInfo`,

  invConfirm: `${url}/inv/confirm`,

  invNotify: `${url}/inv/notify`,

  ticketAbort: `${url}/ticket/abort`,

  ticketConfirm: `${url}/ticket/confirm`,

  queueRedeem: `${url}/queue/gen`,

  removeSubUser: `${url}/user/removeSubUser`,

  removeChild: `${url}/user/removeChild`,

  eventList: `${url}/mpEvent/list`,

  footprintTaskListToday: `${url}/myFootPrint/getTaskListToday`,
  footprintTaskListAll: `${url}/myFootPrint/getTaskListAll`,
  footprintServiceTime: `${url}/myFootPrint/`,
  footprintCreateQRCodeStr: `${url}/myFootPrint/createQRCodeStr`,
  footprintAddTaskBranchFinish: `${url}/myFootPrint/addTaskBranchFinish`,
  spaceTaskListAll: `https://smcp.alipay.com/antExplorer/querySSpaceMonsterList.json`,
  spaceMonsterPhoto: `${url}/monsterPhoto/findByUserId`,
  spaceSaveMonsterPhoto: `${url}/monsterPhoto`,
  uniqueId: `${url}/user/vspCreateWithVid`,
}

export const getCalenders = () => {
  return axios({
    url: api.calenders,
    method: 'get',
  })
}

export const getRescheduleCalenders = (resId) => {
  let params = {
    resId: resId,
  }
  return axios({
    url: api.rescheduleCalenders,
    method: 'get',
    params: params,
  })
}

export const getSchedules = (payload) => {
  let params = {
    date: payload.date,
    userId: payload.userId,
  }
  return axios({
    url: api.schedules,
    method: 'get',
    params: params,
  })
}

export const getUser = (id) => {
  let params = {
    userId: id,
  }
  return axios({
    url: api.user,
    //url: api.test,
    method: 'get',
    //method: 'post',
    params: params,
  })
}

export const getQueueInfo = (userId) => {
  let params = {
    userId: userId,
  }
  return axios({
    url: api.user,
    //url: api.test,
    method: 'get',
    //method: 'post',
    params: params,
  })
}

export const invConfirm = (payload) => {
  let params = {
    userId: payload.userId,
    invCode: payload.invCode,
  }
  return axios({
    url: api.invConfirm,
    method: 'get',
    params: params,
  })
}

export const invReject = (invCode) => {
  let params = {
    status: 3,
    invCode: invCode,
  }
  return axios({
    url: api.invNotify,
    method: 'get',
    params: params,
  })
}

export const resConfirm = (id) => {
  let params = {
    resId: id,
  }
  return axios({
    url: api.resConfirm,
    method: 'get',
    params: params,
  })
}
export const resAbort = (id) => {
  //console.log('abort res', id)
  let params = {
    resId: id,
  }
  return axios({
    url: api.resAbort,
    method: 'get',
    params: params,
  })
}
export const resCancel = (payload) => {
  let params = {
    userId: payload.userId,
    resId: payload.resId,
  }
  return axios({
    url: api.resCancel,
    method: 'get',
    params: params,
  })
}

export const resReschedule = (payload) => {
  let params = {
    resId: payload.resId,
    scheduleId: payload.scheduleId,
  }
  return axios({
    url: api.resReschedule,
    method: 'get',
    params: params,
  })
}

export const ticketAbort = (id) => {
  //console.log('abort ticket', id)
  let params = {
    orderId: id,
  }
  return axios({
    url: api.ticketAbort,
    method: 'get',
    params: params,
  })
}

export const ticketConfirm = (payload) => {
  //console.log('confirm ticket', payload)
  let params = {
    orderId: payload.orderId,
  }
  return axios({
    url: api.ticketConfirm,
    method: 'get',
    params: params,
  })
}

export const queueRedeem = (payload) => {
  let params = {
    userId: payload.userId,
    exhibitId: payload.exhibitId,
  }
  return axios({
    url: api.queueRedeem,
    method: 'get',
    params: params,
  })
}

export const removeSubUser = (payload) => {
  let params = {
    userId: payload.userId,
    subUserId: payload.subUserId,
  }
  //console.log('remove subUser', params)
  return axios({
    url: api.removeSubUser,
    method: 'get',
    params: params,
  })
}

export const getMpEventList = (payload) => {
  //console.log('remove subUser', params)
  return axios({
    url: api.eventList,
    method: 'get',
  })
}

export const getFootprintTaskListToday = (payload) => {
  let params = {
    userId: payload.userId,
  }
  return axios({
    url: api.footprintTaskListToday,
    method: 'get',
    params: params,
  })
  // const data = {
  //   "code": 0,
  //   "msg": "ok",
  //   "subCode": 0,
  //   "data": {
  //     "masterTask": [
  //       { "id": 3, },
  //       { "id": 5, },
  //       { "id": 10, },
  //       { "id": 11, },
  //     ],
  //     "branchTask": [
  //       { "id": 2, },
  //       // { "id": 3, },
  //       // { "id": 5, },
  //       // { "id": 6, },
  //       // { "id": 7, },
  //     ]
  //   }
  // }
  // return new Promise((resolve, reject) => resolve(data.data));
}

export const getFootprintTaskListAll = (payload) => {
  let params = {
    userId: payload.userId,
  }
  return axios({
    url: api.footprintTaskListAll,
    method: 'get',
    params: params,
  })
}

export const getFootprintServiceTime = (payload) => {
  let params = {
    format: payload.format,
  }
  return axios({
    url: api.footprintServiceTime,
    method: 'get',
    params: params,
  })
}

export const getFootprintCreateQRCodeStr = (payload) => {
  let params = {
    userId: payload.userId,
  }
  return axios({
    url: api.footprintCreateQRCodeStr,
    method: 'get',
    params: params,
  })
}

export const getFootprintAddTaskBranchFinish = (payload) => {
  let params = {
    userId: payload.userId,
    taskBranchId: payload.taskBranchId,
  }
  return axios({
    url: api.footprintAddTaskBranchFinish,
    method: 'get',
    params: params,
  })
}

export const getSpaceTaskListAll = (payload) => {
  let data = {
    token: payload.token,
  }
  return axios({
    url: api.spaceTaskListAll,
    method: 'POST',
    data: data,
  })
}

export const getSpaceMonsterPhoto = (payload) => {
  let params = {
    userId: payload.userId,
  }
  return axios({
    url: api.spaceMonsterPhoto,
    method: 'get',
    params: params,
  })
}

export const postSpaceMonsterPhoto = (data) => {
  
  return axios({
    url: api.spaceSaveMonsterPhoto,
    method: 'post',
    headers: {'Content-Type':'multipart/form-data'},
    data: data,
  })
}

export const getUniqueId = (data) => {

  return axios({
    url: api.uniqueId,
    headers: {'Content-Type':'multipart/form-data'},
    method: 'post',
    data: data,
  })
}